import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import useAppointmentStore from '@/store/AppointmentStore';

const useInBranchPreselection = () => {
  const { setSelectedAppointmentType, setPreSelectedZipCode } =
    useAppointmentStore();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const appointmentType = searchParams.get('appointmentType');
    if (appointmentType === 'in-branch') {
      setSelectedAppointmentType('in-branch');
    }

    const preselectedZipCode = searchParams.get('zipCode');
    if (preselectedZipCode?.match(/^\d{5}$/)) {
      setPreSelectedZipCode(preselectedZipCode);
    }
  }, [searchParams, setSelectedAppointmentType, setPreSelectedZipCode]);
};

export default useInBranchPreselection;
